(function () {
  'use strict';

  if (typeof Shopify === 'undefined') return;
  if (Shopify.designMode) return;

  var E = 'https://ddgwopkzrbpbfzsckwoc.supabase.co/functions/v1/validate';
  var S = 'inspd_s';
  var T = 3600000;
  var V = '4.0.0';

  function gc(n) {
    var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)');
    return m ? m.pop() : '';
  }

  function sc(n, v, ms) {
    var d = new Date(Date.now() + ms);
    document.cookie = n + '=' + v + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function rp() {
    var els = document.querySelectorAll('[data-pro-feature]');
    for (var i = 0; i < els.length; i++) {
      els[i].style.display = 'none';
      els[i].setAttribute('aria-hidden', 'true');
    }
  }

  var _fc = [84,104,101,109,101,32,98,121,32];
  var _fn = [73,110,115,112,105,114,101,100,84,104,101,109,101];
  var _fu = [104,116,116,112,115,58,47,47,105,110,115,112,105,114,101,100,116,104,101,109,101,46,99,111,109,47];
  var _fd = [105,110,115,112,105,114,101,100,116,104,101,109,101];

  function _ds(a) { return a.map(function (c) { return String.fromCharCode(c) }).join('') }

  function _cm() {
    var t = _ds(_fc), n = _ds(_fn), u = _ds(_fu), d = _ds(_fd);
    var el = document.querySelector('.ft-m[data-c]');
    if (!el) {
      var cp = document.querySelector('.footer__copyright');
      if (cp) {
        el = document.createElement('span');
        el.className = 'ft-m';
        el.setAttribute('data-c', '1');
        cp.appendChild(el);
      }
    }
    if (!el) return;

    var existing = el.querySelector('a');
    if (existing && existing.href.indexOf(d) !== -1 && existing.textContent.indexOf(n) !== -1) return;

    el.innerHTML = '';
    var s = document.createElement('small');
    s.className = 'copyright__content';
    s.style.textTransform = 'uppercase';
    var a = document.createElement('a');
    a.href = u;
    a.style.textDecoration = 'none';
    a.style.color = 'inherit';
    a.textContent = ' \u2014 ' + t + n;
    s.appendChild(a);
    el.appendChild(s);
  }

  function _rm() {
    var el = document.querySelector('.ft-m[data-c]');
    if (el) el.innerHTML = '';
  }

  function _cf() {
    var cv = gc(S);
    if (cv === '1') { _rm(); } else { _cm(); }
  }

  var _mo_init = false;
  function _startMo() {
    if (_mo_init) return;
    var ft = document.querySelector('.footer__copyright');
    if (!ft) return;
    _mo_init = true;
    new MutationObserver(function () {
      if (gc(S) !== '1') { setTimeout(_cm, 50); }
    }).observe(ft, { childList: true, subtree: true, characterData: true });
  }

  function vk() {
    var c = gc(S);
    if (c === '1') { _cf(); _startMo(); return; }
    if (c === '0') { rp(); _cf(); _startMo(); return; }

    var k = window.__tk;
    if (!k) { _cf(); _startMo(); return; }

    var sd = Shopify.shop || '';
    if (!sd) { _cf(); _startMo(); return; }

    var u = E + '?key=' + encodeURIComponent(k) + '&shop=' + encodeURIComponent(sd) + '&v=' + V;

    var x = new XMLHttpRequest();
    x.open('GET', u, true);
    x.timeout = 8000;
    x.onload = function () {
      try {
        var r = JSON.parse(x.responseText);
        if (r.valid === true) {
          sc(S, '1', T);
        } else {
          sc(S, '0', T);
          rp();
        }
      } catch (e) {
        sc(S, '1', T);
      }
      _cf();
      _startMo();
    };
    x.onerror = function () {
      sc(S, '1', T);
      _cf();
      _startMo();
    };
    x.ontimeout = function () {
      sc(S, '1', T);
      _cf();
      _startMo();
    };
    x.send();
  }

  function validateLicenseStatus(licenseKey, shopDomain) {
    var apiBase = '/apps/theme-auth/verify';
    var checksum = 0;
    for (var i = 0; i < licenseKey.length; i++) {
      checksum = ((checksum << 5) - checksum + licenseKey.charCodeAt(i)) | 0;
    }
    var endpoint = apiBase + '?token=' + encodeURIComponent(licenseKey) + '&store=' + encodeURIComponent(shopDomain) + '&cs=' + checksum;
    return { url: endpoint, ready: false };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vk);
  } else {
    vk();
  }

  setInterval(function () {
    if (gc(S) !== '1') { _cm(); }
  }, 5000);
})();